<template>
  <div>
    <el-card class="box-card">
      <el-form :model="editFormYanfaBx" ref="editFormYanfaBxRef" label-width="170px">
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">供应商(必填)</span>
          </label>
          <el-input v-model="editFormYanfaBx.shoukuandanwei"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">联系方式(必填)</span>
          </label>
          <el-input v-model="editFormYanfaBx.contact"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">材料名称(必填)</span>
          </label>
          <el-input v-model="editFormYanfaBx.productname"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">材料用途(必填)</span>
          </label>
          <el-input v-model="editFormYanfaBx.reason"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">数量(必填)</span>
          </label>
          <el-input v-model="editFormYanfaBx.productnum" @change="countmoney"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">单价(必填)</span>
          </label>
          <el-input v-model="editFormYanfaBx.productprice" @change="countmoney"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">金额(必填)</span>
          </label>
          <el-input v-model="editFormYanfaBx.money" disabled></el-input>
        </el-form-item>
        <el-form-item label="备注(可选)" class="addAdminForm">
          <el-input v-model="editFormYanfaBx.beizhu"></el-input>
        </el-form-item>
        <el-form-item label="附件(可选)" class="addAdminForm">
          <TencentyunCosUploadMultiImgOrPdf ref="MultiImgOrPdf" @change="addTencentyunCosUploadMultiImgOrPdf"></TencentyunCosUploadMultiImgOrPdf>
          默认采用上次的附件，如果附件有改动，请把所有附件都重新上传。
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clicksave">保存</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
import TencentyunCosUploadMultiImgOrPdf from '@/components/TencentyunCosUploadMultiImgOrPdf.vue'
Vue.use(VueAxios, axios)

export default {
  components: {
    TencentyunCosUploadMultiImgOrPdf
  },
  data () {
    return {
      optionsproduct: [],
      editFormYanfaBx: {
        id: 0,
        shoukuandanwei: '',
        contact: '',
        productname: '',
        reason: '',
        productnum: '',
        productprice: '',
        money: '',
        beizhu: '',
        attachment: ''
      }
    }
  },
  mounted () {

  },
  methods: {
    LoadData (row, optionsproduct) {
      console.log(row)
      console.log(optionsproduct)
      this.optionsproduct = optionsproduct

      this.editFormYanfaBx.id = row.Id
      this.editFormYanfaBx.shoukuandanwei = row.Shoukuandanwei
      this.editFormYanfaBx.contact = row.Contact
      this.editFormYanfaBx.productname = row.Productname
      this.editFormYanfaBx.reason = row.Reason
      this.editFormYanfaBx.productnum = row.Productnum
      this.editFormYanfaBx.productprice = row.Productprice
      this.editFormYanfaBx.money = row.Money
      this.editFormYanfaBx.beizhu = row.Beizhu
      this.editFormYanfaBx.attachment = row.Attachment

      this.$refs.MultiImgOrPdf.cleardata()
    },
    countmoney () {
      var m = parseFloat(this.editFormYanfaBx.productnum) * parseFloat(this.editFormYanfaBx.productprice)
      this.editFormYanfaBx.money = m.toFixed(2)
    },
    clickreturn () {
      this.$emit('triggerFunc', '')
    },
    clicksave () {
      this.apiEditShenPiNewFyBxChaiLv4()
    },
    addTencentyunCosUploadMultiImgOrPdf (url) {
      this.editFormYanfaBx.attachment = url
    },
    apiEditShenPiNewFyBxChaiLv4: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: that.editFormYanfaBx.id,
        shoukuandanwei: that.editFormYanfaBx.shoukuandanwei,
        contact: that.editFormYanfaBx.contact,
        productname: that.editFormYanfaBx.productname,
        reason: that.editFormYanfaBx.reason,
        productnum: that.editFormYanfaBx.productnum,
        productprice: that.editFormYanfaBx.productprice,
        money: that.editFormYanfaBx.money,
        beizhu: that.editFormYanfaBx.beizhu,
        attachment: that.editFormYanfaBx.attachment
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditShenPiNewFyBxChaiLv4, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 365px;
}
</style>
